import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Company } from '@lighty';
import { StorageService, TranslateService } from '@services';
import { UrlHelper, DataHelper } from '@helpers';
import { CommonToastService } from '@common2/services/toast.service';

@Component({
    selector: 'msc-organize-user-modal-manage-invitation',
    templateUrl: './manage-invitation.component.html'
})
export class OrganizeUserModalManageInvitationComponent implements OnInit {
    @Input() user: any;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onSend: EventEmitter<any> = new EventEmitter();
    public isActive: boolean = false;
    public invitationType: string = '';
    public data: any;
    public invitationLink: string;
    public company: Company;

    constructor(
        private toastService: CommonToastService,
        private storageService: StorageService,
        private translateService: TranslateService,
    ) { }

    ngOnInit(): void {
        this.isActive = true;

        this.data = {
            notification: 'auto',
            message: ''
        };

        this.company = this.storageService.get('company');

        const baseUrl = (this.user.experience?.customUrl || this.company.customUrl || UrlHelper.getUrl()).replace(/\/+$/, '');

        // Todos los valores van codificados: con nombres compuestos ("Joel José") el
        // espacio crudo hacía que WhatsApp o el correo cortaran el enlace ahí y se
        // perdieran lastname, company, experience y lang (la cuenta quedaba en francés).
        const params = {
            email: this.user.account.email,
            firstname: this.user.account.firstname,
            lastname: this.user.account.lastname,
            company: this.company.slug,
            experience: this.user.experienceSlug || this.company.defaultExperienceSlug,
            lang: this.user.account.language?.code || 'fr'
        };
        const query = Object.keys(params)
            .filter((key) => params[key])
            .map((key) => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        this.invitationLink = `${baseUrl}/signup?${query}`;
    }

    changeType(event: any, type?: string): void {
        this.stopPropagation(event);
        this.invitationType = type ? type : '';
    }

    changeNotification(type: string): void {
        this.data.notification = type;
    }

    stopPropagation(event: any): void {
        event.stopPropagation();
    }

    clipboard(): void {
        DataHelper.clipboard(this.invitationLink);
        this.toastService.onSuccess(this.translateService.instant('toast.link-clipboard'));
    }

    close(): void {
        this.onClose.emit(true);
    }

    send(): void {
        const data = {
            type: 'normal',
            account_id: this.user.account.id,
            message: this.data.notification === 'custom' ? this.data.message : ''
        };
        this.onSend.emit(data);
    }

    sendReminder(): void {
        const data = {
            type: 'reminder',
            account_id: this.user.account.id
        };
        this.onSend.emit(data);
    }
}
